import type { ReactStoryblokComponent } from "types/storyblok";
import { ContainerWithHeader } from "modules/sections/ContainerWithHeader";
import type { ContainerWithHeaderProps } from "modules/sections/ContainerWithHeader";

const ContainerWithHeaderSectionAdapter = ({
  blok: { header, description, bgStyle, components, id, display },
  sbEditable,
}: ReactStoryblokComponent<ContainerWithHeaderProps>) => (
  <ContainerWithHeader
    sbEditable={sbEditable}
    header={header}
    description={description}
    bgStyle={bgStyle}
    components={components}
    id={id}
    display={display}
  />
);

export default ContainerWithHeaderSectionAdapter;
